import { css, Global } from '@emotion/react';

export const GlobalStyles = () => (
  <Global
    styles={css`
      html,
      body,
      #root {
        height: 100%;
      }

      body {
        margin: 0;
      }

      a {
        text-decoration: none;
      }
    `}
  />
);

export default GlobalStyles;
